<script lang="ts">
  import { slide } from 'svelte/transition'
  import { screen } from '#app/lib/components/stores/screen'
  import { icon } from '#app/lib/icons'
  import { onChange } from '#app/lib/svelte/svelte'
  import { objectEntries } from '#app/lib/utils'
  import SearchSection from '#search/components/search_section.svelte'
  import type { SerializedSearchResult } from '#search/lib/search_results'
  import { sections, type SearchCategory, type SearchSection as SearchSectionT } from '#search/lib/search_sections'
  import type { EntityUri } from '#server/types/entity'
  import { I18n } from '#user/lib/i18n'

  let {
    showSearchControls = $bindable(),
    selectedCategory = $bindable(),
    selectedSection = $bindable(),
    results,
    uri,
  }: {
    showSearchControls?: boolean
    selectedCategory?: SearchCategory
    selectedSection?: SearchSectionT
    results: SerializedSearchResult[]
    uri: EntityUri
  } = $props()

  function letRoomForResults () {
    if (results?.length > 0 && $screen.isSmallerThan('$small-screen')) {
      showSearchControls = false
    } else {
      showSearchControls = true
    }
  }

  $effect(() => {
    onChange(results, $screen, letRoomForResults)
  })
</script>

<div class="search-settings-toggler-wrapper">
  <button
    class="search-settings-toggler"
    aria-controls="searchControls"
    onclick={() => showSearchControls = !showSearchControls}
  >
    {#if showSearchControls}
      {@html icon('chevron-down')}
    {:else}
      {@html icon('chevron-up')}
    {/if}
    <span class="label">{I18n('search settings')}</span>
  </button>
</div>

{#if showSearchControls && uri == null}
  <div id="searchControls" class="sections" in:slide|local>
    <div class="entity-sections">
      {#each objectEntries(sections.entity) as [ sectionName, section ] (sectionName)}
        <SearchSection
          category="entity"
          name={sectionName}
          label={section.label}
          bind:selectedCategory
          bind:selectedSection
        />
      {/each}
    </div>
    <!-- Typo on purpose: .socialSections is blocked by this popular ad blocker list: https://secure.fanboy.co.nz/fanboy-annoyance.txt -->
    <div class="sozial-sections">
      {#each objectEntries(sections.social) as [ sectionName, section ] (sectionName)}
        <SearchSection
          category="social"
          name={sectionName}
          label={section.label}
          bind:selectedCategory
          bind:selectedSection
        />
      {/each}
    </div>
  </div>
{/if}

<style lang="scss">
  @import "general/scss/utils";
  .search-settings-toggler-wrapper{
    @include display-flex(row, center, flex-end);
    display: none;
  }
  .sections{
    background-color: #eee;
  }
  .entity-sections, .sozial-sections{
    @include display-flex(row, flex-end, flex-start, wrap);
    text-align: center;
    overflow-x: auto;
  }
  .entity-sections{
    border-block-end: 1px solid #ccc;
  }

  /* Smaller screens */
  @media screen and (width < $small-screen){
    .search-settings-toggler-wrapper{
      margin-block-start: auto;
      @include display-flex(row, center, center);
    }
    .search-settings-toggler{
      flex: 1 0 auto;
      height: 2.5em;
      @include display-flex(row, center, center);
      background-color: #f3f3f3;
      padding: 0.4em 0.2em;
      margin: 0.1em 1em 0;
      @include radius-top(5px);
      @include radius-bottom(0);
      :global(.fa){
        font-size: 1.5rem;
      }
      :global(.fa-chevron-up){
        @include transition(transform, 0.5s);
        margin-block-start: -0.2em;
      }
      .label{
        padding-inline: 0.2em 0.5em;
      }
    }
  }
</style>
